import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { TrendingUp, ShoppingBag, Users, Package, Crown } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, Bar, BarChart } from "recharts";

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data));
  }, []);

  if (!data) return <div className="p-10 text-white/40 tracking-luxury uppercase text-sm">Loading…</div>;

  return (
    <div className="p-8 md:p-12">
      <header className="mb-10">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier Overview</p>
        <h1 className="font-serif text-5xl mt-2">Dashboard.</h1>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-poche-gold/15">
        {[
          { i: TrendingUp, l: "Revenue", v: `$${data.total_revenue.toLocaleString()}` },
          { i: ShoppingBag, l: "Orders", v: data.total_orders },
          { i: Users, l: "Customers", v: data.total_customers },
          { i: Package, l: "Products", v: data.total_products },
          { i: Crown, l: "Legacy Pending", v: data.legacy_pending },
        ].map((m, i) => (
          <div key={i} className="bg-poche-ink p-6" data-testid={`metric-${m.l.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex items-center justify-between">
              <m.i size={18} className="text-poche-gold" strokeWidth={1.4} />
            </div>
            <div className="num-ticker !text-3xl mt-3 text-poche-gold">{m.v}</div>
            <div className="text-[10px] tracking-luxury uppercase text-white/45 mt-2">{m.l}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10">
        <div className="lg:col-span-2 bg-poche-ink border border-white/10 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-[11px] tracking-luxury uppercase text-poche-gold">Revenue · 7 days</h3>
          </div>
          <div style={{ width: "100%", height: 260 }}>
            <ResponsiveContainer>
              <LineChart data={data.revenue_series}>
                <XAxis dataKey="date" tick={{ fill: "#aaa", fontSize: 10 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill: "#aaa", fontSize: 10 }} axisLine={false} tickLine={false} />
                <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid rgba(201,168,100,0.3)", borderRadius: 0 }} />
                <Line type="monotone" dataKey="revenue" stroke="#C9A864" strokeWidth={1.5} dot={{ fill: "#C9A864", r: 3 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-poche-ink border border-white/10 p-6">
          <h3 className="text-[11px] tracking-luxury uppercase text-poche-gold">Recent Orders</h3>
          <div className="mt-4 space-y-3">
            {data.recent_orders.slice(0, 6).map((o) => (
              <div key={o.order_id} className="flex items-center justify-between text-sm border-b border-white/5 pb-2">
                <div>
                  <div className="text-[10px] tracking-luxury uppercase text-white/55">#{o.order_id.slice(-6).toUpperCase()}</div>
                  <div className="text-xs">{o.customer_name || o.customer_email}</div>
                </div>
                <div className="font-serif text-poche-gold">${o.total.toLocaleString()}</div>
              </div>
            ))}
            {data.recent_orders.length === 0 && <div className="text-xs text-white/45">No orders yet</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
